<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="flexd">
              <v-avatar size="150" tile>
                <img
                  :src="
                    data.user_photo
                      ? $store.state.urlImages + data.user_photo
                      : require('@/assets/no-image.jpg')
                  "
                  :alt="data.user_login"
                  @click="$refs.fileInput.click()"
                />
                <input
                  type="file"
                  label="Foto:"
                  accept="image/jpeg, image/png"
                  @change="uploadImage"
                  ref="fileInput"
                  style="display: none"
                />
              </v-avatar>
              <p>Clique na imagem para adicionar foto</p>
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Login"
                  :rules="fieldRules"
                  v-model="data.user_login"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field label="Senha" v-model="data.user_password" />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Grupo:"
                  :rules="fieldRules"
                  :items="groups"
                  @change="getTable(data.group_id)"
                  item-value="group_id"
                  item-text="group_name"
                  v-model="data.group_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Selecione uma opção:"
                  :disabled="table && table.length > 0 ? false : true"
                  :items="table"
                  :item-value="
                    data.table_key == 'providers'
                      ? 'provider_id'
                      : data.table_key == 'prefectures'
                      ? 'prefecture_id'
                      : data.table_key == 'drivers'
                      ? 'driver_id'
                      : data.table_key == 'attendants'
                      ? 'attendant_id'
                      : ''
                  "
                  :item-text="
                    data.table_key == 'providers'
                      ? 'provider_name'
                      : data.table_key == 'prefectures'
                      ? 'prefecture_social_name'
                      : data.table_key == 'drivers'
                      ? 'driver_name'
                      : data.table_key == 'attendants'
                      ? 'attendant_name'
                      : ''
                  "
                  v-model="data.table_id"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    groups: [],
    table: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      user_login: "",
      user_password: null,
      user_photo: "",
      group_id: null,
      table_id: null,
      table_key: "",
    },
  }),
  created() {
    this.$http.get("/access-groups").then((r) => (this.groups = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`users/${this.id}`).then((r) => {
        this.data = r.data[0];
        this.getTable(this.data.group_id);
        delete this.data.created_at;
        this.$store.dispatch("setLoader", false);
        // this.data.user_password = null;
      });
    }
  },
  methods: {
    getTable(gid) {
      const tb = this.groups.filter((v) => v.group_id == gid && v);
      this.table = [];
      setTimeout(() => {
        const vl = this.$store.getters.getModules.filter(
          (nv) => nv.nome.toLowerCase() == tb[0].group_name.toLowerCase() && nv
        );
        if (vl) {
          this.data.table_key = vl[0].name;
          this.$http(`/${vl[0].name}`)
            .then((r) => (this.table = r.data))
            .catch(() => (this.table = []));
        } else {
          this.table = [];
        }
      }, 400);
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/users/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push("/users-manager");
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/users", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            setTimeout(() => {
              this.$router.push("/users-manager");
            }, 1500);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
    uploadImage(event) {
      this.$store.dispatch("setLoader", true);
      const fd = new FormData();
      fd.append("image", event.target.files[0], event.target.files[0].name);
      console.log(event.target.files[0]);
      this.$http
        .post("/upload", fd)
        .then((r) => {
          this.data.user_photo = r.data.cover;
          console.log(r.data);
          this.$store.dispatch("setLoader", false);
        })
        .catch((e) => {
          alert(
            "Erro ao realizar upload da imagem tente novamente! " + e.message
          );
          this.$store.dispatch("setLoader", false);
          event.target.files = [];
        });
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>